import React from 'react';

const VoucherVerifySuccessIcon = (props) => (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.504 1.31836C15.5773 1.31836 19.6916 5.43268 19.6916 10.506C19.6916 15.5792 15.5773 19.6936 10.504 19.6936C5.43073 19.6936 1.31641 15.5792 1.31641 10.506C1.31641 5.43268 5.43073 1.31836 10.504 1.31836ZM8.59609 13.4902L6.34674 11.2389C5.96353 10.8555 5.96345 10.2302 6.34674 9.84687C6.73011 9.46358 7.35817 9.46598 7.73875 9.84687L9.32453 11.4339L13.2694 7.48901C13.6528 7.10564 14.2781 7.10564 14.6614 7.48901C15.0448 7.8723 15.0442 8.49819 14.6614 8.88102L10.0194 13.523C9.63659 13.9058 9.01069 13.9064 8.6274 13.523C8.61663 13.5123 8.60624 13.5013 8.59609 13.4902Z"
      fill="#00BA00"
    />
  </svg>
);

export default VoucherVerifySuccessIcon;
